import React, { useEffect, useRef, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faChartPie, faCoins, faDoorOpen, faEllipsisVertical, faFile, faGlobe, faHouse, faLayerGroup,
  faMagnifyingGlass, faTrash, faWallet, faXmark, faCopy
} from "@fortawesome/free-solid-svg-icons";
import { InputOtp } from "@heroui/react";
import Send from "./Send/Send";
import Deposit from "./Deposit/Deposit";
import Transactionhistory from "./Transactionhistory/Transactionhistory";
import Dashboard from "./Dashboard/Dashboard";
import Withdraw from "./Withdraw/Withdraw";
import HeaderLayout from "../Layout/HeaderLayout";
import SelectNetwork from "./SelectNetwork/SelectNetwork";
import toast from "react-hot-toast";
import { useLocation, useNavigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { SERVER_URL, AVALANCHE_URL } from "../../Config";
import axios from "axios";
import Bar from "../CSS/Bar";
import Sidebar from "../Layout/Sidebar";
import { ClipLoader } from "react-spinners";
import { QRCodeCanvas } from "qrcode.react";


export default function MyDashboard({ }) {

  const [walletType, setwalletType] = useState(null)
  const [createWallet, setCreateWallet] = useState(false);
  const [importWallet, setImportWallet] = useState(false);
  const [selectNetwork, setSelectNetwork] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isSidebarMobile, setIsSidebarMobile] = useState(false);
  const [selectedAccount, setSelectedAccount] = useState(null);
  const [showPopup, setShowPopup] = useState(null);
  const [importantnotice, setImportantnotice] = useState(false);
  const [note_popup, setNote_popup] = useState(false);
  const popupRef = useRef(null);
  const [showLoader, setshowLoader] = useState(false)
  const [walletData, setwalletData] = useState({
    'account_name': '',
    'recovery_phrase': '',
    'app_id': '',
    'appPin': '',
  })
  const [UserAccounts, setUserAccounts] = useState([])
  const navigate = useNavigate()

  const [viewAccount, setViewAccount] = useState(false);
  const [accountDetails, setAccountDetails] = useState(null);
  const [keyPopUp, setKeyPopUp] = useState(false);
  const [keyType, setKeyType] = useState(null);
  const [keyPass, setKeyPass] = React.useState("");
  const [keyAnswer, setKeyAnswer] = useState(null);
  const [isError, setIsError] = useState(false);
  const [isErrorMsg, setIsErrorMsg] = useState(null);

  const [userKey, setUserKey] = useState(null);
  const [showKey, setShowKey] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [selectWallet, setSelectWallet] = useState(null);

  const handleDelete = async () => {
    try {
      setShowModal(false);
      const response = await axios.post(`${SERVER_URL}/api/deleteAccount`, { address: selectWallet?.wallet_address },
        {
          headers: {
            Authorization: `Bearer ${sessionStorage.getItem('_token')}`,
            "Content-Type": "application/json",
          },
        }
      );
      if (response.data.status) {
        toast.success("Wallet Removed Successfully!");
        getUserdatas();
      } else {
        toast.success("An error occurred while deleting the account.");
      }

    } catch (error) {
      console.error("Error deleting account:", error);
      toast.error(error.response?.data?.msg || "An error occurred while deleting the account.");
    }
  };

  const handleKey = (type) => {
    if (type === 'privatekey') {
      setKeyType("privatekey");
      setViewAccount(false);
      setKeyPopUp(true);
    }
    if (type === 'secretphase') {
      setKeyType("secretphase");
      setViewAccount(false);
      setKeyPopUp(true);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      if (popupRef.current && !popupRef.current.contains(event.target)) {
        setShowPopup(null);
      }
    }

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const dropdownRef = useRef(null);
  const buttonRef = useRef(null);

  const handleClickOutside = (event) => {
    if (
      isSidebarMobile &&
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef.current &&
      !buttonRef.current.contains(event.target)
    ) {
      setIsSidebarMobile(false);
    }
  };

  useEffect(() => {
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isSidebarMobile]);

  const [activeTab, setActiveTab] = useState("Dashboard");
  const location = useLocation();
  const [userData, setuserData] = useState([])

  const handleTabClick = (tab) => setActiveTab(tab);

  const chooseAccount = (data) => {
    setshowLoader(true);
    sessionStorage.setItem('selectedAccount', data.wallet_address);
    setSelectedAccount(data.wallet_addresss);
    setSelectNetwork(false);
    setShowPopup(null);
    setTimeout(() => {
      setshowLoader(false)
      toast.success('Account changed Successfully')
    }, 1000)
  }

  const sendCreateWallet = async () => {
    try {
      if (!walletData.account_name) {
        toast.error('Account name needed');
        return;
      }
      setshowLoader(true);

      const Datas = {
        app_id: userData.app_id,
        account_name: walletData.account_name,
        appPin: walletData.appPin,
      };

      const res = await axios.post(`${SERVER_URL}/api/registerasNewWallet`, Datas, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('_token')}`, },
      });

      if (res.data.status) {
        setUserAccounts(res.data.UserAccounts);
        toast.success('Account created successfully');
        setCreateWallet(false);
        setSelectNetwork(true);
        setShowPopup(null);
        getUserdatas()
        setwalletData({
          account_name: '',
          app_id: '',
          appPin: '',
        });
      } else {
        toast.error(res.data.msg || 'Failed to create wallet.');
      }
    } catch (err) {
      console.error(err);
      toast.error('An unexpected error occurred. Please try again.');
    } finally {
      setshowLoader(false);
      return false
    }
  };

  const sendImportWallet = async () => {
    try {
      if (!walletData.recovery_phrase) {
        toast.error('Recovery phrase needed');
        return;
      }
      if (!walletData.account_name) {
        toast.error('Account name needed');
        return;
      }

      if (!walletData.appPin) {
        toast.error('App Pin needed');
        return;
      }

      const accountExists = UserAccounts.some(
        (value) => value.account_name === walletData.account_name
      );
      if (accountExists) {
        toast.error('Account name already exists!');
        return;
      }

      const phraseWords = walletData.recovery_phrase.trim().split(/\s+/);
      if (phraseWords.length < 12 || phraseWords.length > 24) {
        toast.error('Recovery phrase must be between 12 to 24 words.');
        return;
      }

      setshowLoader(true);

      const requestData = {
        input: walletData.recovery_phrase,
        app_id: userData.app_id,
        appPin: walletData.appPin,
        account_name: walletData.account_name,
      };

      const res = await axios.post(`${SERVER_URL}/api/registerasImportWallet`, requestData, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('_token')}`, },
      });

      if (res.data.status) {
        setUserAccounts(res.data.userAccounts);
        toast.success('Account imported successfully');
        setCreateWallet(false);
        setSelectNetwork(true);
        setShowPopup(null);
        getUserdatas()
        setwalletData({
          account_name: '',
          recovery_phrase: '',
          appPin: '',
        });
      } else {
        toast.error(res.data.msg || 'Import failed. Please check your details.');
      }
    } catch (err) {
      console.error(err);
      toast.error('An unexpected error occurred. Please try again later.');
    } finally {
      setshowLoader(false);
    }
  };

  const getUserdatas = async () => {
    try {
      const token = sessionStorage.getItem('_token');
      if (!token) {
        toast.error('Session Expired');
        navigate('/Login');
        return;
      }

      const decodedToken = jwtDecode(token);
      const res = await axios.get(`${SERVER_URL}/api/getUserdatas?AppID=${decodedToken.AppID}`, {
        headers: { Authorization: `Bearer ${sessionStorage.getItem('_token')}`, },
      });

      if (res.data.status) {

        setuserData(res.data.User);
        setUserAccounts(res.data.accounts)
        const choosedAccount = sessionStorage.getItem('selectedAccount');

        if (!choosedAccount) {
          setSelectedAccount(res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null);
          sessionStorage.setItem('selectedAccount', res.data.accounts.length > 0 ? res.data.accounts[0].wallet_address : null)
        } else {
          setSelectedAccount(sessionStorage.getItem('selectedAccount'))
        }
      } else {
        setuserData([]);
        setSelectedAccount(null);
      }
    } catch (error) {
      console.error('Error fetching user data:', error);

      if (error.response?.status === 403) {
        toast.error('Session expired');
        navigate('/Login');
      } else {
        toast.error('Something went wrong. Please try again.');
      }
    }
  };

  useEffect(() => {
    const token = sessionStorage.getItem('_token');
    if (token) {
      getUserdatas();
    }
  }, [sessionStorage.getItem('_token')]);

  const TabButton = ({ icon, label, tab, action }) => (
    <button
      className={`flex items-center w-full px-5 py-2  ${tab === activeTab ? "bg-[#4169E114] text-[#856E4F]" : ""
        } ${isSidebarMobile ? "justify-start rounded-md" : "justify-center rounded-xl"}`}
      onClick={() => handleTabClick(tab)}
    >
      <span className={`flex items-center gap-3`}>
        {icon}
        {isSidebarMobile && <span className="text-sm">{label}</span>}
      </span>
    </button>
  );

  const Logout = () => {
    sessionStorage.removeItem('_token');
    toast.success('Logout Successfull')
    navigate('/login')
  }

  useEffect(() => {
    if (activeTab === "Logout") {
      Logout();
    }
  }, [activeTab]);

  const handleCopy = (address) => {
    navigator.clipboard.writeText(address).then(() => {
      toast.success("Copied to clipboard!");
    }).catch(err => {
      console.error("Failed to copy:", err);
    });
  };

  const handleConfirm = async () => {
    try {
      const token = sessionStorage.getItem('_token');

      if (!keyPass || keyPass.length < 6) {
        setIsError(true);
        setIsErrorMsg("Enter a 6-digit PIN");
        return;
      }

      setIsError(false);
      setIsErrorMsg(null);

      const response = await axios.post(`${SERVER_URL}/api/verifyUsersAnswer`, {
        AppID: userData.app_id,
        pass: keyPass,
        type: keyType,
        wallet: accountDetails?.wallet_address,
      }, { headers: { Authorization: `Bearer ${token}` } });

      if (response.data.status === true) {
        setUserKey(response.data.data);
        setShowKey(true);
        setKeyPopUp(false);
      } else {
        setIsError(true);
        setIsErrorMsg(response.data.message);
      }
    } catch (error) {
      console.error("Error during verification: ", error);
      setIsError(true);
      setIsErrorMsg(error?.response?.data?.message || "Something went wrong. Try again.");
    }
  };


  return (
    <div className="font-san relative bg-black bg-cover min-h-screen bg-no-repeat text-white transition-all ease-in-out duration-500">
      {showLoader && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            background: "rgba(0, 0, 0, 0.5)", // Semi-transparent background
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            zIndex: 9999, // Ensures overlay appears on top
            backdropFilter: "blur(5px)", // Apply blur effect to background
          }}
        >
          <div className="flex flex-col gap-4 justify-center items-center">
            <ClipLoader color="#ffffff" size={50} />
            <p style={{ color: "#ffffff", fontSize: "18px" }} className="text-center">
              Loading...
            </p>
          </div>

        </div>
      )}
      <div className="flex w-[100%] sticky top-0 z-50">
        <div className=" px-5 pt-7 z-50 bg-black">
          <button className="hidden md:block" onClick={() => setIsSidebarOpen(!isSidebarOpen)} >
            <Bar />
          </button>
          <div>
            <button ref={buttonRef} className="md:hidden block" onClick={() => setIsSidebarMobile(!isSidebarMobile)} >
              <Bar />
            </button>
            {isSidebarMobile && (
              <div ref={dropdownRef}
                className="absolute z-50 bg-black rounded-lg py-2 left-4 top-14 fade-in-left block md:hidden" onClick={() => setIsSidebarMobile(!isSidebarMobile)}>
                <div className="flex flex-col gap-5 text-[#A7A8AB]">
                  <TabButton
                    icon={<FontAwesomeIcon icon={faHouse} size="lg" />}
                    tab="Dashboard"
                    label="Dashboard"
                  />
                  <TabButton
                    icon={<FontAwesomeIcon icon={faLayerGroup} size="lg" />}
                    tab="Send"
                    label="Send"
                  />
                  <TabButton
                    icon={<FontAwesomeIcon icon={faWallet} size="lg" />}
                    tab="Deposit"
                    label="Deposit"
                  />
                  <TabButton
                    icon={<FontAwesomeIcon icon={faChartPie} size="lg" />}
                    tab="Transaction"
                    label="Transaction"
                  />
                  <TabButton
                    icon={<FontAwesomeIcon icon={faCoins} size="lg" />}
                    tab="Withdraw"
                    label="Withdraw"
                  />
                  <TabButton onClick={Logout}
                    icon={<FontAwesomeIcon icon={faDoorOpen} size="lg" />}
                    tab="Logout"
                    label="Logout"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
        <HeaderLayout
          tab={activeTab}
          setSelectNetwork={setSelectNetwork}
          User={userData}
        />
      </div>
      <div className=" md:flex ">
        <Sidebar
          activeTab={activeTab}
          handleTabClick={handleTabClick}
          isSidebarOpen={isSidebarOpen}
          setIsSidebarOpen={setIsSidebarOpen}
        />
        <div
          className={` transition-all duration-500 ${isSidebarOpen ? "w-[95%] md:w-[80%]" : "md:w-[80%] w-[95%]"} mx-auto`}>
          <div>
            {activeTab === "Dashboard" && <Dashboard setSelectNetwork={setSelectNetwork} setImportWallet={setImportWallet} />}
            {activeTab === "SelectNetwork" && <SelectNetwork />}
            {activeTab === "Send" && <Send />}
            {activeTab === "Deposit" && <Deposit />}
            {activeTab === "Transaction" && <Transactionhistory />}
            {activeTab === "Withdraw" && <Withdraw />}
            {activeTab === "Logout" && <p>Logging Of</p>}
          </div>

          {createWallet && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in" >
              <div className="w-[90%] md:w-[50%] lg:w-[35%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
                <div className="flex justify-end pt-2 px-2">
                  <button onClick={() => setCreateWallet(false)} className="text-white">
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
                <div className="text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
                  <h2 className="text-2xl font-semibold font-Artemus ">Create Wallet</h2>
                  <input className="border border-white/20 outline-none w-[100%] mt-3 bg-transparent py-2 rounded-lg px-3"
                    value={walletData.account_name}
                    onChange={(e) => setwalletData((prevData) => ({ ...prevData, account_name: e.target.value }))}
                    placeholder="Enter wallet name"
                  ></input>
                  <input
                    className="border border-white/20 outline-none w-full mt-3 bg-transparent py-2 rounded-lg px-3"
                    value={userData.app_id}
                    onChange={(e) => setwalletData((prevData) => ({ ...prevData, app_id: e.target.value }))}
                    placeholder={userData.app_id}
                  />
                  <input
                    type="password"
                    className="border border-white/20 outline-none w-full mt-3 bg-transparent py-2 rounded-lg px-3"
                    value={walletData.appPin}
                    onChange={(e) => {
                      const input = e.target.value;
                      if (/^\d{0,6}$/.test(input)) {
                        setwalletData((prevData) => ({ ...prevData, appPin: input }));
                      }
                    }}
                    placeholder="Enter App Pin"
                    maxLength={6}
                  />
                  <div className="mt-5 flex gap-3">
                    <button onClick={sendCreateWallet}
                      className="w-1/2 px-6 py-1 bg-[#FFFFD9] text-black font-semibold rounded-full"
                    >
                      Confirm
                    </button>
                    <button onClick={() => {
                      setwalletData({
                        user_id: '',
                        wallet_type: '',
                        account_name: '',
                        p_key: '',
                        app_id: '',
                        app_id: '',
                        appPin: '',
                        question_id: '',
                        answer: '',
                      });
                      setCreateWallet(false)
                    }}
                      className="w-1/2 px-6 py-1 border-2 border-[#FFFFD9] text-[#fffd9] font-semibold rounded-full"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {importWallet && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in" >
              <div className="w-[90%] md:w-[50%] lg:w-[35%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
                <div className="flex justify-end pt-2 px-2">
                  <button
                    onClick={() => {
                      setImportWallet(false);
                      setwalletData({ account_name: '', recovery_phrase: '', appPin: '' });
                    }}
                    className="text-white"
                  >
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
                <div className="text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
                  <h2 className="text-2xl font-semibold font-Artemus ">Import Wallet</h2>
                  <p className="text-[11px] 2xl:text-sm text-red-500 mt-2">Note : Imported Wallets won’t be associated with your Secret Recovery Phrase. </p>
                  <textarea
                    value={walletData.recovery_phrase}
                    className="border border-white/20 w-full mt-3 bg-transparent py-2 rounded-lg px-3"
                    placeholder="Enter your secret recovery phrase (e.g., hen dog zebra...)"
                    onChange={(e) => setwalletData((prev) => ({ ...prev, recovery_phrase: e.target.value }))}
                  ></textarea>
                  <input
                    type="text"
                    value={walletData.account_name}
                    className="border border-white/20 w-full mt-3 bg-transparent py-2 rounded-lg px-3"
                    placeholder="Enter your Account Name"
                    onChange={(e) => setwalletData((prev) => ({ ...prev, account_name: e.target.value }))}
                  />
                  <input
                    type="email"
                    value={userData.app_id}
                    className="border border-white/20 w-full mt-3 bg-transparent py-2 rounded-lg px-3"
                    placeholder={userData.app_id}
                    onChange={(e) => setwalletData((prev) => ({ ...prev, app_id: e.target.value }))}
                  />

                  <input
                    type="password"
                    value={walletData.appPin}
                    className="border border-white/20 w-full mt-3 bg-transparent py-2 rounded-lg px-3"
                    placeholder="Enter your App Pin"
                    maxLength={6}
                    onChange={(e) => {
                      const value = e.target.value;
                      if (/^\d*$/.test(value) && value.length <= 6) {
                        setwalletData((prev) => ({ ...prev, appPin: value }));
                      }
                    }}
                  />


                  <div className="mt-5 flex gap-3">
                    <button onClick={sendImportWallet}
                      className="w-1/2 px-6 py-1 bg-[#FFFFD9] text-black font-semibold rounded-full"
                    >
                      Import Wallet
                    </button>
                    <button onClick={() => {
                      setwalletData({
                        recovery_phrase: '',
                        account_name: '',
                        app_id: '',
                        appPin: '',

                      });
                      setImportWallet(false)
                    }}
                      className="w-1/2 px-6 py-1 border-2 border-[#FFFFD9] text-[#fffd9] font-semibold rounded-full"
                    >
                      Cancel
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {selectNetwork && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in"
              style={{
                backdropFilter: "blur(10px)",
                WebkitBackdropFilter: "blur(10px)",
              }}
            >
              <div className="w-[90%] md:w-[50%] lg:w-[30%] lg:h-auto bg-[#252728] border border-[#FFF2C25E] rounded-xl">
                <div className="flex justify-end pt-2 px-3">
                  <button onClick={() => setSelectNetwork(false)} className="text-white">
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>

                <div className="relative text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
                  <h2 className="text-2xl font-semibold">Select an Account</h2>
                  <div className="relative mt-3">
                    <FontAwesomeIcon icon={faMagnifyingGlass} className="absolute left-3 top-3 text-white/20" />
                    <input
                      type="search"
                      className="border border-white/20 outline-none w-[100%] bg-transparent py-2 px-10 rounded-full"
                      placeholder="Search"
                    />
                  </div>

                  <div className="mt-3 text-left">
                    <h1 className="font-semibold">Created Accounts</h1>
                    <div
                      className="mt-3 max-h-64 overflow-y-auto rounded-lg p-3"
                      style={{
                        scrollbarWidth: "thin",
                        scrollbarColor: "white transparent",
                      }}
                    >
                      {UserAccounts && UserAccounts.length > 0 ? (
                        UserAccounts.map((data) => (
                          <div
                            className={` flex justify-between items-center mt-3 hover:bg-[#454136] rounded-lg p-3 ${selectedAccount === data.wallet_address ? 'bg-[#3a3b3f]' : ''}`}
                            key={data.wallet_address}
                          >
                            <div className=" flex items-center gap-5 cursor-pointer">
                              <img
                                src="https://static.vecteezy.com/system/resources/thumbnails/028/149/256/small_2x/3d-user-profile-icon-png.png"
                                className="w-7 rounded-full"
                                alt="User Icon"
                              />
                              <div className="flex flex-col" onClick={() => chooseAccount(data)}>
                                <p>{data.wallet_name}</p>
                                <p className="text-xs text-white/50">{data.wallet_address?.substring(0, 15)}...</p>
                                {sessionStorage.getItem('selectedAccount').toLowerCase() == data?.wallet_address?.toLowerCase() ? (
                                  <p className="text-xs text-green-400">Connected</p>
                                ) : ''}
                              </div>
                            </div>

                            <div className="text-right">
                              <p className="font-semibold">$ {Number(data?.erc20Balances).toFixed(2)}</p>
                            </div>

                            <div className="">
                              <FontAwesomeIcon
                                icon={faEllipsisVertical}
                                onClick={(e) => {
                                  e.stopPropagation();
                                  setShowPopup((prev) => (prev === data.wallet_address ? null : data.wallet_address));
                                  setSelectWallet((prev) => (prev === data ? null : data));
                                }}
                                className="cursor-pointer"
                              />

                              {showPopup === data.wallet_address && (
                                <div
                                  className="absolute top-30 right-[-30] bg-[#333] text-md text-white rounded-lg shadow-lg p-4 z-10"
                                  ref={popupRef}
                                  style={{ minWidth: "220px", minHeight: '160px' }}
                                >
                                  <ul>
                                    <li className="py-2 px-2 flex items-center gap-2 hover:bg-[#454136] rounded cursor-pointer" onClick={() => { setViewAccount(true); setAccountDetails(data) }}>
                                      <FontAwesomeIcon icon={faFile} />
                                      Account Details
                                    </li>
                                    <li className="py-2 px-2 flex items-center gap-2 hover:bg-[#454136] rounded cursor-pointer" onClick={() => window.open(`${AVALANCHE_URL}${data.wallet_address}`, "_blank")}>
                                      <FontAwesomeIcon icon={faGlobe} />
                                      View in Explorer
                                    </li>
                                    <li
                                      className="py-2 px-2 flex items-center gap-2 text-red-400 hover:bg-[#454136] rounded cursor-pointer"
                                      onClick={() => {
                                        setShowModal(!showModal);
                                      }}
                                    >
                                      <FontAwesomeIcon style={{ color: 'red' }} icon={faTrash} />
                                      Remove Account
                                    </li>
                                  </ul>
                                </div>
                              )}
                            </div>
                          </div>
                        ))
                      ) : (
                        <div className="text-center text-gray-400 mt-8">
                          <p className="text-lg font-semibold">No Wallets Created</p>
                          <p className="text-sm">Start by Adding or Importing a wallet.</p>
                        </div>
                      )}
                    </div>
                  </div>

                  <div className="mt-5 gap-3 flex flex-row">
                    <button
                      onClick={() => {
                        setSelectNetwork(false);
                        setCreateWallet(true);
                        setwalletType('new')
                      }}
                      className="w-[100%] px-3 py-2 border border-[#FFFFD9] text-[#FFFFD9] font-medium rounded-full hover:bg-[#FFFFD9] hover:text-black transition-all"
                    >
                      + Add an Account
                    </button>
                    <button
                      onClick={() => {
                        setSelectNetwork(false);
                        setImportWallet(true);
                        setwalletType('import')
                      }}
                      className="w-[100%] px-6 py-2 border border-[#FFFFD9] text-[#FFFFD9] font-medium rounded-full hover:bg-[#FFFFD9] hover:text-black transition-all"
                    >
                      + Import an Account
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {viewAccount && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in"
              style={{ backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", }}>
              <div className="w-[90%] md:w-[40%] lg:w-[30%] lg:h-auto bg-[#252728] border border-[#FFF2C25E] rounded-xl">
                <div className="flex justify-end pt-2 px-3">
                  <button onClick={() => { setViewAccount(false); }} className="text-white">
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>

                <div className="relative text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
                  <h2 className="text-2xl font-semibold pb-5"> {accountDetails?.wallet_name ?? "Account"}</h2>

                  <div className="z-30 items-center pb-5 flex justify-center">
                    {accountDetails && (
                      <QRCodeCanvas
                        value={accountDetails?.wallet_address}
                        size={150}
                        bgColor="#252728"
                        fgColor="#fff"
                        className=" border border-[#FFF2C25E] p-2  rounded-xl items-center"
                      />
                    )}
                  </div>

                  <p className="w-full text-center break-all text-sm pb-5">
                    {accountDetails?.wallet_address}
                  </p>

                  <button
                    disabled={selectedAccount === "null"}
                    className="z-20 "
                    onClick={() => { handleCopy(accountDetails?.wallet_address) }}><FontAwesomeIcon icon={faCopy} className="pr-3" />
                    Copy address
                  </button>

                  <div className="mt-5 gap-3 flex flex-row">
                    <button onClick={() => { handleKey("privatekey") }}
                      className="w-[100%] px-3 py-2 border border-[#FFFFD9] text-[#FFFFD9] font-medium rounded-full hover:bg-[#FFFFD9] hover:text-black transition-all"
                    >
                      Private Key
                    </button>

                    <button onClick={() => { handleKey("secretphase") }}
                      className="w-[100%] px-6 py-2 border border-[#FFFFD9] text-[#FFFFD9] font-medium rounded-full hover:bg-[#FFFFD9] hover:text-black transition-all"
                    >
                      Secret Recovery Phrase
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {keyPopUp && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 text-white fade-in"
              style={{ backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)" }}>
              <div className="w-[90%] md:w-[50%] lg:w-[35%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
                <div className="flex justify-end pt-2 px-2">
                  <button onClick={() => setKeyPopUp(false)} className="text-white">
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
                <div className="text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
                  <h2 className="text-2xl font-semibold font-Artemus">Show Private Key</h2>

                  <div className="flex justify-center mt-3 text-white">
                    <InputOtp
                      value={keyPass || ""}
                      onValueChange={setKeyPass}
                      length={6}
                      type="number"
                      variant="bordered"
                      style={{ color: "white" }}
                      className="flex gap-2 text-white"
                      inputClassName="w-12 h-12 bg-transparent border border-white/20 text-center rounded-lg text-lg 
                      focus:border-[#FFFFD9] focus:ring-2 focus:ring-[#FFFFD9] outline-none transition-all 
                      placeholder-white"
                    />
                  </div>
                  {isError && isErrorMsg && (
                    <p className="text-red-500 text-xs mt-1">{isErrorMsg}</p>
                  )}

                  <p className="w-full break-all text-sm py-5">
                    Warning: Never disclose this key. Anyone with your private keys can steal any assets held in your account.
                  </p>

                  <div className="mt-5 flex justify-center gap-3">
                    <button onClick={handleConfirm} className="w-1/2 px-6 py-2 bg-[#FFFFD9] text-black font-semibold rounded-full hover:bg-[#FFF2C2] transition-all">
                      Confirm
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {showKey && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in"
              style={{ backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)" }}
            >
              <div className="w-[90%] md:w-[50%] lg:w-[35%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
                <div className="flex justify-end pt-2 px-2">
                  <button onClick={() => { setShowKey(false); setKeyPopUp(false); setViewAccount(false); setKeyAnswer(null); setKeyPass("") }} className="text-white">
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
                <div className="text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
                  <h2 className="text-2xl font-semibold font-Artemus">Keep your private key safe</h2>

                  <p className="w-full break-all text-sm py-5">
                    Your Private Key provides <b>full access to your wallet and funds.</b>
                  </p>

                  <p className="w-full break-all text-sm py-5">
                    <b>Do not share this with anyone.</b>
                  </p>
                  <div
                    className="border border-white/20 outline-none w-full mt-3 bg-transparent py-2 rounded-lg px-3 text-white placeholder-gray-400 text-center 
                                break-words whitespace-pre-wrap"
                  >
                    {userKey}
                  </div>

                  <div className="mt-5 flex justify-center gap-3">
                    <button
                      onClick={() => handleCopy(userKey)}
                      className="w-1/2 px-6 py-2 bg-[#FFFFD9] text-black font-semibold rounded-full hover:bg-[#FFF2C2] transition-all"
                    >
                      Copy
                    </button>
                  </div>
                </div>
              </div>
            </div>
          )}

          {importantnotice && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in" >
              <div className="w-[90%] md:w-[50%] lg:w-[37.5%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
                <div className="flex justify-end pt-2 px-2">
                  <button onClick={() => setImportantnotice(false)} className="text-white">
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
                <div className="text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
                  <h2 className="text-2xl font-semibold font-Artemus ">⚠️ Important Notice</h2>
                  <p className='mt-3 text-sm leading-6 font-normal text-justify'>By continuing, you acknowledge that all transactions on Stabilix are conducted at your own discretion. As a decentralized platform, Stabilix does not oversee or intervene in user transactions and is not responsible for any agreements, disputes, or outcomes arising from platform usage.</p>
                  <button className='mt-5 bg-white w-[70%] rounded-full py-2 font-Artemus font-semibold text-black'>OK</button>
                </div>
              </div>
            </div>
          )}

          {note_popup && (
            <div className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in" >
              <div className="w-[90%] md:w-[50%] lg:w-[37.5%] bg-[#252728] border border-[#FFF2C25E] rounded-xl">
                <div className="flex justify-end pt-2 px-2">
                  <button onClick={() => setNote_popup(false)} className="text-white">
                    <FontAwesomeIcon icon={faXmark} />
                  </button>
                </div>
                <div className="text-white text-center px-5 md:px-7 2xl:px-10 pb-7">
                  <h2 className="text-2xl font-semibold font-Artemus "> Note </h2>
                  <p className='mt-3 text-sm leading-6 font-normal text-justify'><span className='font-bold'>Stabilix</span> does not hold or control funds and cannot mediate disputes.</p>
                  <button className='mt-5 bg-white w-[70%] rounded-full py-2 font-Artemus font-semibold text-black'>OK</button>
                </div>
              </div>
            </div>
          )}

          {showModal && (
            <div
              className="fixed inset-0 flex items-center justify-center bg-black/75 z-50 fade-in"
              style={{ backdropFilter: "blur(10px)", WebkitBackdropFilter: "blur(10px)", }}>
              <div className="w-[90%] md:w-[50%] lg:w-[30%] bg-[#252728] border border-[#FFF2C25E] rounded-xl p-6 shadow-lg text-center">
                <h2 className="text-lg font-bold mb-3">Are you sure?</h2>
                <p className="text-gray-300 mb-4">This action cannot be undone.</p>
                <div className="flex justify-center gap-4">
                  <button
                    className="bg-gray-600 hover:bg-gray-700 px-4 py-2 rounded"
                    onClick={() => setShowModal(false)}
                  >Cancel</button>
                  <button
                    className="bg-red-600 hover:bg-red-700 px-4 py-2 rounded"
                    onClick={handleDelete}
                  >Yes, Delete</button>
                </div>
              </div>
            </div>
          )}

        </div>
      </div>
    </div >
  );
}